// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"673":"720b5df6","3394":"2d387084","5751":"2d387084","9053":"2d387084","9358":"3a223acf"}[chunkId] + ".chunk.css";
};